
/**
 * 트윗 유형
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
